import { useAtom } from '@reatom/npm-react'

import { CurrencyCell } from '@root/entities/currency/ui/cells/currency-cell'
import { TierRank } from '@root/entities/tier-rank'

import type { OrderModel } from '@root/entities/order/atoms'
import type { ClassNameProps } from '@root/shared/lib/react'

type Props = {
  order: OrderModel
} & ClassNameProps

export const OrdersTableCurrencyCell: React.FC<Props> = ({
  className,
  order,
}) => {
  const [tier] = useAtom(order.order.pair.premiumInfo.tier)
  const tierRank = tier ? TierRank.fromPremiumTier(tier) : undefined

  return (
    <CurrencyCell
      className={className}
      pairAddress={order.order.pair.address}
      currency={order.order.pair.quote}
      tierRank={tierRank}
    />
  )
}
